module.exports = __webpack_public_path__ + "static/windows-6c251269e1646db838872c18be14acb9.jpg";